var React = require('react');

function ArrowButton (props) {
    return React.createElement("svg",props,React.createElement("g",{"className":"ArrowButton"},[React.createElement("g",{"fill":"none","stroke":"#fff","strokeWidth":"2.5","key":0},[React.createElement("circle",{"cx":"33","cy":"33","r":"33","stroke":"none","key":0}),React.createElement("circle",{"cx":"33","cy":"33","r":"31.75","key":1})]),React.createElement("circle",{"cx":"33","cy":"33","r":"33","fill":"rgba(255,255,255,.8)","className":"circle-solid","key":1}),React.createElement("g",{"fill":"none","stroke":"#858486","strokeLinecap":"round","strokeWidth":"3","className":"arrow","key":2},[React.createElement("path",{"strokeLinejoin":"round","d":"M45.11,38l-12.08,11.32-12.14-11.32","className":"pointer","key":0}),React.createElement("path",{"d":"M32.9,48V13","className":"line","key":1})])]));
}

ArrowButton.defaultProps = {"width":"66","height":"66","viewBox":"0 0 66 66"};

module.exports = ArrowButton;

ArrowButton.default = ArrowButton;
